import ApplicationLoader from "@/containers";

import ThumbsContainer from "./ThumbsContainer";

const AppLoader = new ApplicationLoader(ThumbsContainer);

AppLoader.start();

export { ThumbsProps } from "./ThumbsContainer";
